module.exports = __webpack_public_path__ + "img/Airbnb-Working-from-a-listing-What-to-Pack-1.3bc7f2cc.jpg";